import React from 'react';
export function Footer() {
  return <footer className="bg-[#0B1426] border-t border-gray-800 py-12" data-id="element-82">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-83">
        <div className="mb-8" data-id="element-84">
          <p className="text-gray-400 font-bold mb-2" data-id="element-85">PRODUCTO DIGITAL</p>
          <p className="text-gray-500 text-sm" data-id="element-86">
            Este producto es digital y se envía automáticamente después de la
            compra.
            <br data-id="element-87" />
            Acceso inmediato.
          </p>
        </div>

        <div className="text-gray-600 text-sm" data-id="element-88">
          <p data-id="element-89">© 2025 Mega Kit Neuro-Pro. Todos los derechos reservados.</p>
          <p className="mt-2 text-xs" data-id="element-90">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}